export default {"src":"/_next/static/media/checkmarkBlack.c0709616.svg","height":6,"width":7};